import {
  customProvider,
} from 'ai';
import { openai } from '@ai-sdk/openai';

// Simplified provider for production - no test environment needed
export const myProvider = customProvider({
  languageModels: {
    'chat-model': openai('o3'),
    'title-model': openai('o3'), // @todo Drop
  },
});
